import { render } from "./StoreUpdateNotificationSettings.vue?vue&type=template&id=30fe5c2a"
import script from "./StoreUpdateNotificationSettings.vue?vue&type=script&lang=js"
export * from "./StoreUpdateNotificationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__